import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GasRadioComponent } from './radio/gas-radio.component';
import { GasRadioGroupComponent } from './group/gas-radio-group.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';

const COMPONENTS = [
  GasRadioComponent,
  GasRadioGroupComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GasIconsModule,
  ],
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
})
export class GasRadioModule { }
